import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {
    changePersonalCustomsClearanceScenes,
    updateCustomsCodeCodes,
    initCustomsCodeCodes,
    getCustomsByApis,
} from '@web/actions/personalCustomsClearance'
import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {selectUses, getInitialState} from '@web/slices/personalCustomsClearance/slice'

import type {PersonalCustomsClearanceReducers, MakeCreateSliceOptions} from './interfaces'
import type {PersonalCustomsClearanceState} from '@web/slices/personalCustomsClearance/slice'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<
        PersonalCustomsClearanceState,
        PersonalCustomsClearanceReducers,
        'personalCustomsClearance',
        SliceSelectors<PersonalCustomsClearanceState>
    >({
        name: 'personalCustomsClearance',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(selectUses, (state, {payload}) => {
                state.uses = payload
            })
            options?.extraReducers?.(builder)
            builder
                .addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                    return payload.personalCustomsClearance ?? state
                })
                .addMatcher(initCustomsCodeCodes, (state) => {
                    state.code = ''
                })
                .addMatcher(updateCustomsCodeCodes, (state, {payload}) => {
                    if (payload.saved) {
                        state.selected = {
                            id: payload.saved.id,
                            view: payload.code ?? '',
                            hash: payload.hash ?? '',
                            name: payload.saved.name,
                            phone: payload.saved.phone,
                        }
                        state.code = ''
                    } else {
                        state.code = payload.code ?? ''
                    }
                })
                .addMatcher(changePersonalCustomsClearanceScenes, (state, {payload}) => {
                    state.screenScene = payload.scene
                })
                .addMatcher(getCustomsByApis, (state, {payload}) => {
                    state.customsCode = {
                        view: payload.personalCustomCode ?? '',
                        hash: payload.hash ?? '',
                    }
                })
        },
    })
